<template>
    <form @submit.prevent="submit">
        <div class="form-item">
            <label for="prenom">Prénom *</label>
            <input type="text" id="prenom" required v-model="user.first_name">
        </div>
        <p v-for="error in errors.get('first_name')" class="error">{{ error }}</p>

        <div class="form-item">
            <label for="nom">Nom *</label>
            <input type="text" id="nom" required v-model="user.last_name">
        </div>
        <p v-for="error in errors.get('last_name')" class="error">{{ error }}</p>

        <div class="form-item">
            <label for="email-register">Email *</label>
            <input type="email" id="email-register" required v-model="user.email">
        </div>
        <p v-for="error in errors.get('email')" class="error">{{ error }}</p>

        <div class="form-item">
            <label for="password-register">Mot de passe *</label>
            <input type="password" id="password-register" required v-model="user.password">
        </div>
        <p v-for="error in errors.get('password')" class="error">{{ error }}</p>

        <div class="form-item">
            <label for="confirm-password">Confirmation du mot de passe *</label>
            <input type="password" id="confirm-password" required v-model="user.password_confirmation">
        </div>
        <p v-if="user.password_confirmation !== user.password" class="error">
            La confirmation du champ Mot de passe ne correspond pas.
        </p>
        <p v-if="wordpress_errors" class="error" v-for="error in wordpress_errors">{{ error }}</p>

        <div class="cta">
            <div></div>
            <button type="submit" class="btn chevron">S'inscrire</button>
        </div>

    </form>
</template>

<script>
    import axios from 'axios';
    import Errors from '../Errors';

    export default {
        data: () => ({
            loading: false,
            errors: new Errors(),
            user: {},
            wordpress_errors:null,
            redirect: location.href
        }),
        props: {
            isoption: {
                type: Boolean,
                required: true,
            },
        },
        methods: {
            submit() {
                this.loading = true;
                this.errors.clear();
                axios.post(`${window.GrandsEspaces.adminUrl}?action=ge_register_user`, this.user)
                    .then(() => {
                        this.loading = false;
                        // TODO show message
                        // window.location.reload(true);
                        window.location.href = this.redirect
                    })
                    .catch(({response}) => {

                        if (response.status === 400) {
                            this.errors.record(response.data.errors);
                        }
                        if (response.status === 500){
                            this.wordpress_errors = response.data.errors
                        }
                        this.loading = false;
                    });
            },
        },
        created(){
            if (this.isoption){
                this.redirect = location.href + '?is_option=' + this.isoption
            }
        }
    };
</script>



// WEBPACK FOOTER //
// assets/js/components/RegisterForm.vue